import React from 'react';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';

const PracticeAreaTags = ({ column, practiceAreaList }) => {
  // Handle default column (all practice areas)
  if (column?.is_default) {
    return (
      <div className="practice-area-section">
        <Tag className="p-mr-2 pa-tags" rounded value="All Practice Areas" />
      </div>
    );
  }

  // Handle no practice areas assigned
  if (!column?.practice_area || column.practice_area.length === 0) {
    return (
      <div className="practice-area-section">
        <p className="no-pa mb-1 ms-1">No practice area assigned</p>
      </div>
    );
  }

  // Get the first practice area
  const firstPracticeArea = practiceAreaList?.find((area) => area.sk === column.practice_area[0]);

  // Generate sanitized ID for tooltip
  const sanitizedSk = column?.sk?.replace(/[^a-zA-Z0-9_-]/g, '_');

  return (
    <div className="practice-area-section">
      {firstPracticeArea && (
        <Tag
          key={firstPracticeArea.sk}
          className="p-mr-2 pa-tags"
          rounded
          value={firstPracticeArea.practice_area_name + (firstPracticeArea.status === 'ARCHIVED' ? ' (Inactive)' : '')}
        />
      )}

      {/* Show "+X more" tag if there are additional practice areas */}
      {column.practice_area.length > 1 && (
        <>
          <Tag
            className={`p-mr-2 pa-tags pointer more-tag more-tag-${sanitizedSk}`}
            rounded
            value={`+${column.practice_area.length - 1} more`}
          />
          <Tooltip target={`.more-tag-${sanitizedSk}`} position="bottom" className="pa-tooltip" style={{ bottom: 0 }}>
            {column.practice_area
              .slice(1)
              .map((item, index, array) => {
                const matchingArea = practiceAreaList?.find((option) => option.sk === item);

                if (matchingArea) {
                  const practiceAreaName = matchingArea.practice_area_name;
                  const status = matchingArea.status;
                  return (
                    <span key={item}>
                      {practiceAreaName}
                      {status === 'ARCHIVED' && ' (Inactive)'}
                      {index < array.length - 1 && (
                        <>
                          {','}
                          &nbsp;
                        </>
                      )}
                    </span>
                  );
                }
                return null;
              })
              .filter(Boolean)}
          </Tooltip>
        </>
      )}
    </div>
  );
};

export default PracticeAreaTags;
